import { Component, OnInit } from '@angular/core';
import { ActionItemRegisterService } from '../services/action-item-register.service';
import { LabelConstants } from '../../shared/constants/label-constants';
import { ActionItemRegisterConstants } from '../action-item-register-constants';

@Component({
  selector: 'app-action-item-library',
  templateUrl: './action-item-library.component.html',
  styleUrls: ['./action-item-library.component.scss']
})
export class ActionItemLibraryComponent {
  topBarTitle: string = ActionItemRegisterConstants.ActionItemLibraryTitle;
  isScreenAccessible: boolean = false;
  errorMessage!: string;
  enableCheckBoxes: boolean = false;

  constructor(private actionItemRegisterService: ActionItemRegisterService) { }

  ngOnInit(): void {
    this.actionItemRegisterService.actionItemAuthorization().subscribe({
      error: (err: any) => {
        if (err.status === LabelConstants.Forbidden_StatusCode) {
          this.errorMessage = err.error.detail;
        }
        this.isScreenAccessible = false;
      },
      next: (serviceData: boolean) => {
        if (serviceData) {
          this.isScreenAccessible = serviceData;
        } else {
          this.errorMessage = ActionItemRegisterConstants.ActionItemRegister_Page_Validation;
          this.isScreenAccessible = false;
        }
      },
    });
  }

}
